const isIE = /Trident\/|MSIE/.test(window.navigator.userAgent);
const isEdge = /Edg/.test(window.navigator.appVersion);
const isIEorEdge = isIE || isEdge;

export {isIE, isEdge, isIEorEdge};
